import {
  CompobotConfigType,
  CompobotGuiVersionType,
} from '../types/compobotGuiVersion.type';
import { ApiClient } from './interceptor';

const api = ApiClient.getInstance();

export const getCompobotConfigForAdmin = async (id: string) => {
  return await api.get(`compobot-config/info/config/${id}`);
};

export const getCompobotConfigsForAdmin = async (
  searchParams?: Partial<CompobotConfigType>,
) => {
  return await api.get('compobot-config/info/config', searchParams);
};

export const getAllGuiVersions = async () => {
  return await api.get('compobot-config/info/gui-version');
};

export const getCompobotGuiVersionByCompobotId = async (compobotId: string) => {
  return await api.get(`compobot-config/info/gui-version/${compobotId}`);
};

export const getCompobotGuiVersionById = async (id: string) => {
  return await api.get(`compobot-config/info/gui-version-by-id/${id}`);
};

export const editCompobotConfig = async (
  compobotId: string,
  cbConfig?: Partial<CompobotConfigType>,
) => {
  return await api.put(`compobot-config/create/config/${compobotId}`, cbConfig);
};

export const editCompobotGuiVersion = async (
  GuiConfig?: Partial<CompobotGuiVersionType>,
) => {
  return await api.put('compobot-config/create/gui-version', GuiConfig);
};

export const createCompobotGuiVersion = async (
  GuiConfig?: Partial<CompobotGuiVersionType>,
) => {
  return await api.post('compobot-config/create/new-gui-version', GuiConfig);
};

export const deleteGuiVersion = async (versionName: string) => {
  return await api.delete(`compobot-config/delete/gui-version/${versionName}`);
};

export const getCompobotConfig = async (compobotId: string) => {
  return await api.get(`compobot-config/compobot/info/${compobotId}`);
};
